import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { PricingItemVersion } from '../../models/quote/pricing-item-version';
import { ProductManagerV2Service } from './product-manager-v2.service';
import { Page } from '../../utils/page';
import { ProductSearchRequestV2 } from '../../models/quote/product-search-request-v2';
import { ProductMapperV2Service } from './product-mapper-v2.service';
import { ProductWithChildrenV2 } from '../../models/productv2/productv2-children.model';
import { PriceList } from '../../models/productv2/pricelist.model';

@Injectable()
export class RemoteProductManagerV2Service extends ProductManagerV2Service {

    constructor(private http: HttpClient, protected productMapper: ProductMapperV2Service) {
        super(productMapper);
    }

    searchArticles(productSearchRequest: ProductSearchRequestV2, pageable: Map<string, string>): Observable<Page<ProductWithChildrenV2>> {
        return this.processSearchArticles(productSearchRequest, pageable, false);
    }

    searchAtomicArticles(productSearchRequest: ProductSearchRequestV2, pageable: Map<string, string>): Observable<Page<ProductWithChildrenV2>> {
        return this.processSearchArticles(productSearchRequest, pageable, true);
    }

    private processSearchArticles(productSearchRequest: ProductSearchRequestV2, pageable: Map<string, string>, onlyAtomic: boolean): Observable<Page<ProductWithChildrenV2>> {
        let params = new HttpParams();
        pageable.forEach((value, key) => params = params.set(key, value));
        Object.entries(productSearchRequest).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                params = params.set(key, value.toString());
            }
        });

        let url = `${this.API_URL}${onlyAtomic ? '/products/search-atomic' : '/products/search'}`;
        return this.http.get<Page<ProductWithChildrenV2>>(url, { params });
    }

    getActivePricingItemVersion(countryIsoCode: string, versionType: string): Observable<PricingItemVersion> {
        return this.http.get(this.API_URL + `/versions/active/${countryIsoCode}/${versionType}`);
    }

    getClassification(id: number): Observable<PriceList> {
        return this.http.get(this.API_URL + `/pricelists/${id}`).pipe(
            map(classification => this.productMapper.hydratePriceList(classification))
        );;
    }

    searchArticlesByFilteredElisCodes(productSearchRequestV2: ProductSearchRequestV2): Observable<{ content: ProductWithChildrenV2[] }> {
        if (!productSearchRequestV2.elisCodeList?.length) {
            return new Observable(observer => {
                observer.next({ content: [] });
                observer.complete();
            });
        }
        let size = productSearchRequestV2.elisCodeList?.length;
        let pageable = new Map()
            .set('page', 0)
            .set('size', size);

        return this.searchArticles(productSearchRequestV2, pageable).pipe(
            map(page => ({ content: page.content }))
        );
    }


}
